import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';
import { ElementImageIcon } from 'src/components/ElementImageIcon/ElementImageIcon';
import * as styles from './Card.module.scss';

function Card({ index, positions, item }) {
  return (
    <Col key={item._key} xs={5} className={`${styles.cardColors} position-relative rounded-2xl p-4 ${positions[index]}`}>
      <Col className="mb-5 pb-5">
        <ElementImageIcon icon={item.icon} />
      </Col>
      <Col className="rfs-size-3xl font-weight-bold pt-4">{item.title}</Col>
      <Col className="font-weight-bold">{item.description}</Col>
    </Col>
  );
}

Card.propTypes = {
  index: PropTypes.number.isRequired,
  positions: PropTypes.arrayOf(PropTypes.string).isRequired,
  item: PropTypes.shape({
    icon: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    _key: PropTypes.string.isRequired,
  }).isRequired,
};

export default Card;
